var _defs, _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHbomax(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 240,
    zoomAndPan: "magnify",
    viewBox: "0 0 180 67.499998",
    height: 90,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "1b9a2d95c7"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "808e84cc6c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.660156 18.046875 L 76 18.046875 L 76 49.316406 L 0.660156 49.316406 Z M 0.660156 18.046875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ff38c60dc4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 78 18.046875 L 179.335938 18.046875 L 179.335938 49.316406 L 78 49.316406 Z M 78 18.046875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "36bfc64f65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 119.703125 29.414062 C 119.542969 22 114.351562 18.078125 107.996094 18.078125 C 104.511719 18.078125 101.363281 19.261719 99.222656 21.558594 C 97.082031 19.261719 93.9375 18.078125 90.449219 18.078125 C 84.09375 18.078125 78.90625 22.015625 78.742188 29.429688 C 78.742188 29.449219 78.742188 29.464844 78.742188 29.480469 L 78.742188 46.394531 C 78.742188 47.953125 79.992188 49.199219 81.515625 49.199219 L 84.144531 49.199219 C 84.402344 49.199219 84.613281 48.988281 84.613281 48.722656 L 84.613281 29.464844 C 84.726562 25.804688 87.289062 23.871094 90.449219 23.871094 C 93.613281 23.871094 96.175781 25.804688 96.289062 29.464844 L 96.289062 46.378906 C 96.289062 47.9375 97.539062 49.183594 99.0625 49.183594 L 101.6875 49.183594 C 101.949219 49.183594 102.160156 48.96875 102.160156 48.707031 L 102.160156 29.449219 C 102.273438 25.789062 104.835938 23.855469 107.996094 23.855469 C 111.160156 23.855469 113.722656 25.789062 113.835938 29.449219 L 113.835938 46.363281 C 113.835938 47.921875 115.082031 49.167969 116.605469 49.167969 L 119.234375 49.167969 C 119.492188 49.167969 119.703125 48.953125 119.703125 48.691406 L 119.703125 29.429688 C 119.722656 29.449219 119.703125 29.429688 119.703125 29.414062 Z M 178.84375 18.554688 L 174.386719 18.554688 C 173.152344 18.554688 172 19.179688 171.304688 20.210938 L 166.375 27.59375 C 165.726562 28.5625 164.332031 28.5625 163.683594 27.59375 L 158.753906 20.210938 C 158.070312 19.179688 156.902344 18.554688 155.671875 18.554688 L 151.210938 18.554688 C 150.9375 18.554688 150.773438 18.867188 150.921875 19.097656 L 159.710938 32.285156 C 160.34375 33.238281 160.34375 34.484375 159.710938 35.4375 L 150.921875 48.625 C 150.757812 48.855469 150.9375 49.167969 151.210938 49.167969 L 155.671875 49.167969 C 156.902344 49.167969 158.054688 48.542969 158.753906 47.511719 L 163.683594 40.128906 C 164.332031 39.160156 165.726562 39.160156 166.375 40.128906 L 171.304688 47.511719 C 171.984375 48.542969 173.152344 49.167969 174.386719 49.167969 L 178.84375 49.167969 C 179.121094 49.167969 179.28125 48.855469 179.136719 48.625 L 170.332031 35.453125 C 169.699219 34.5 169.699219 33.253906 170.332031 32.300781 L 179.121094 19.113281 C 179.28125 18.882812 179.121094 18.554688 178.84375 18.554688 Z M 148.910156 18.554688 L 146.28125 18.554688 C 144.953125 18.554688 143.835938 19.507812 143.558594 20.769531 C 141.222656 18.964844 138.289062 18.046875 135.125 18.046875 C 127.441406 18.046875 121.195312 23.460938 121.195312 33.679688 C 121.195312 43.902344 127.421875 49.316406 135.125 49.316406 C 138.273438 49.316406 141.175781 48.414062 143.511719 46.640625 C 143.640625 48.066406 144.824219 49.199219 146.28125 49.199219 L 148.910156 49.199219 C 149.167969 49.199219 149.378906 48.988281 149.378906 48.722656 L 149.378906 19.03125 C 149.363281 18.769531 149.167969 18.554688 148.910156 18.554688 Z M 135.125 43.507812 C 130.535156 43.507812 126.808594 40.113281 126.808594 33.695312 C 126.808594 27.28125 130.535156 23.886719 135.125 23.886719 C 139.714844 23.886719 143.445312 27.28125 143.445312 33.695312 C 143.445312 40.113281 139.714844 43.507812 135.125 43.507812 Z M 135.125 43.507812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 3080.599922,
    gradientTransform: "matrix(0.16216, 0, 0, 0.164052, -420.807625, 50.873162)",
    y1: -104.745003,
    x2: 3700.599924,
    gradientUnits: "userSpaceOnUse",
    y2: -104.745003,
    id: "61ade5e9c1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.999084%, 11.799622%, 92.199707%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.750366%, 11.813354%, 91.989136%)",
    offset: 0.00390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.503174%, 11.828613%, 91.778564%)",
    offset: 0.0078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.25293%, 11.842346%, 91.566467%)",
    offset: 0.0117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.004211%, 11.857605%, 91.355896%)",
    offset: 0.015625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.753967%, 11.871338%, 91.143799%)",
    offset: 0.0195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.503723%, 11.886597%, 90.931702%)",
    offset: 0.0234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.253479%, 11.901855%, 90.719604%)",
    offset: 0.0273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.003235%, 11.917114%, 90.509033%)",
    offset: 0.03125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.752991%, 11.930847%, 90.296936%)",
    offset: 0.0351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.504272%, 11.946106%, 90.086365%)",
    offset: 0.0390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.254028%, 11.959839%, 89.874268%)",
    offset: 0.0429688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.003784%, 11.975098%, 89.66217%)",
    offset: 0.046875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.75354%, 11.988831%, 89.450073%)",
    offset: 0.0507812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.504822%, 12.004089%, 89.239502%)",
    offset: 0.0546875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.254578%, 12.019348%, 89.027405%)",
    offset: 0.0585938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.004333%, 12.034607%, 88.815308%)",
    offset: 0.0625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.754089%, 12.04834%, 88.60321%)",
    offset: 0.0664062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.505371%, 12.063599%, 88.392639%)",
    offset: 0.0703125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.255127%, 12.077332%, 88.180542%)",
    offset: 0.0742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.004883%, 12.09259%, 87.968445%)",
    offset: 0.078125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.754639%, 12.107849%, 87.756348%)",
    offset: 0.0820313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.50592%, 12.123108%, 87.545776%)",
    offset: 0.0859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.255676%, 12.136841%, 87.333679%)",
    offset: 0.0898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.005432%, 12.1521%, 87.121582%)",
    offset: 0.09375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.755188%, 12.165833%, 86.909485%)",
    offset: 0.0976562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.504944%, 12.181091%, 86.698914%)",
    offset: 0.101562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.2547%, 12.194824%, 86.486816%)",
    offset: 0.105469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.005981%, 12.210083%, 86.274719%)",
    offset: 0.109375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.755737%, 12.225342%, 86.062622%)",
    offset: 0.113281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.505493%, 12.240601%, 85.852051%)",
    offset: 0.117188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.255249%, 12.254333%, 85.639954%)",
    offset: 0.121094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.006531%, 12.269592%, 85.429382%)",
    offset: 0.125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.756287%, 12.283325%, 85.217285%)",
    offset: 0.128906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.506042%, 12.298584%, 85.005188%)",
    offset: 0.132812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.255798%, 12.312317%, 84.793091%)",
    offset: 0.136719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.00708%, 12.327576%, 84.58252%)",
    offset: 0.140625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.756836%, 12.342834%, 84.370422%)",
    offset: 0.144531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.506592%, 12.358093%, 84.158325%)",
    offset: 0.148438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.256348%, 12.371826%, 83.946228%)",
    offset: 0.152344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.007629%, 12.387085%, 83.735657%)",
    offset: 0.15625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.757385%, 12.400818%, 83.52356%)",
    offset: 0.160156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.507141%, 12.416077%, 83.311462%)",
    offset: 0.164063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.256897%, 12.42981%, 83.099365%)",
    offset: 0.167969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.006653%, 12.445068%, 82.888794%)",
    offset: 0.171875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.756409%, 12.460327%, 82.676697%)",
    offset: 0.175781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.50769%, 12.475586%, 82.4646%)",
    offset: 0.179688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.257446%, 12.489319%, 82.252502%)",
    offset: 0.183594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.007202%, 12.504578%, 82.041931%)",
    offset: 0.1875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.756958%, 12.518311%, 81.829834%)",
    offset: 0.191406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.50824%, 12.533569%, 81.617737%)",
    offset: 0.195312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.257996%, 12.548828%, 81.40564%)",
    offset: 0.199219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.007751%, 12.564087%, 81.195068%)",
    offset: 0.203125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.757507%, 12.57782%, 80.982971%)",
    offset: 0.207031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.508789%, 12.593079%, 80.770874%)",
    offset: 0.210937
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.258545%, 12.606812%, 80.558777%)",
    offset: 0.214844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.008301%, 12.62207%, 80.348206%)",
    offset: 0.21875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.758057%, 12.635803%, 80.136108%)",
    offset: 0.222656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.509338%, 12.651062%, 79.925537%)",
    offset: 0.226562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.259094%, 12.666321%, 79.71344%)",
    offset: 0.230469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.00885%, 12.68158%, 79.501343%)",
    offset: 0.234375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.758606%, 12.695312%, 79.289246%)",
    offset: 0.238281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.508362%, 12.710571%, 79.078674%)",
    offset: 0.242188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.258118%, 12.724304%, 78.866577%)",
    offset: 0.246094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.009399%, 12.739563%, 78.65448%)",
    offset: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.759155%, 12.753296%, 78.442383%)",
    offset: 0.253906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.508911%, 12.768555%, 78.231812%)",
    offset: 0.257813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.258667%, 12.783813%, 78.019714%)",
    offset: 0.261719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.009949%, 12.799072%, 77.807617%)",
    offset: 0.265625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.759705%, 12.812805%, 77.59552%)",
    offset: 0.269531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.50946%, 12.828064%, 77.384949%)",
    offset: 0.273438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.259216%, 12.841797%, 77.172852%)",
    offset: 0.277344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.010498%, 12.857056%, 76.960754%)",
    offset: 0.28125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.760254%, 12.872314%, 76.748657%)",
    offset: 0.285156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.51001%, 12.887573%, 76.538086%)",
    offset: 0.289062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.259766%, 12.901306%, 76.325989%)",
    offset: 0.292969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.011047%, 12.916565%, 76.113892%)",
    offset: 0.296875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.760803%, 12.930298%, 75.901794%)",
    offset: 0.300781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.510559%, 12.945557%, 75.691223%)",
    offset: 0.304688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.260315%, 12.95929%, 75.479126%)",
    offset: 0.308594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.010071%, 12.974548%, 75.268555%)",
    offset: 0.3125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.759827%, 12.989807%, 75.056458%)",
    offset: 0.316406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.511108%, 13.005066%, 74.84436%)",
    offset: 0.320312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.260864%, 13.018799%, 74.632263%)",
    offset: 0.324219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.01062%, 13.034058%, 74.421692%)",
    offset: 0.328125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.760376%, 13.047791%, 74.209595%)",
    offset: 0.332031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.511658%, 13.063049%, 73.997498%)",
    offset: 0.335938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.261414%, 13.076782%, 73.7854%)",
    offset: 0.339844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.011169%, 13.092041%, 73.574829%)",
    offset: 0.34375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.760925%, 13.1073%, 73.362732%)",
    offset: 0.347656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.512207%, 13.122559%, 73.150635%)",
    offset: 0.351562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.261963%, 13.136292%, 72.938538%)",
    offset: 0.355469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.011719%, 13.15155%, 72.727966%)",
    offset: 0.359375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.761475%, 13.165283%, 72.515869%)",
    offset: 0.363281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.512756%, 13.180542%, 72.303772%)",
    offset: 0.367188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.262512%, 13.194275%, 72.091675%)",
    offset: 0.371094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.012268%, 13.209534%, 71.881104%)",
    offset: 0.375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.762024%, 13.224792%, 71.669006%)",
    offset: 0.378906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.51178%, 13.240051%, 71.456909%)",
    offset: 0.382812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.261536%, 13.253784%, 71.244812%)",
    offset: 0.386719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.012817%, 13.269043%, 71.034241%)",
    offset: 0.390625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.762573%, 13.282776%, 70.822144%)",
    offset: 0.394531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.512329%, 13.298035%, 70.610046%)",
    offset: 0.398438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.5047%, 13.298035%, 70.603943%)",
    offset: 0.40625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.498596%, 13.299561%, 70.599365%)",
    offset: 0.4375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.498596%, 13.299561%, 70.599365%)",
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.498596%, 13.299561%, 70.599365%)",
    offset: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.498596%, 13.299561%, 70.599365%)",
    offset: 0.6875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.498596%, 13.299561%, 70.599365%)",
    offset: 0.71875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.510803%, 13.298035%, 70.608521%)",
    offset: 0.726563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(34.887695%, 13.276672%, 70.927429%)",
    offset: 0.730469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.25238%, 13.25531%, 71.237183%)",
    offset: 0.734375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.617065%, 13.233948%, 71.546936%)",
    offset: 0.738281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(35.983276%, 13.212585%, 71.856689%)",
    offset: 0.742188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.347961%, 13.189697%, 72.164917%)",
    offset: 0.746094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(36.714172%, 13.168335%, 72.47467%)",
    offset: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.078857%, 13.146973%, 72.784424%)",
    offset: 0.753906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.445068%, 13.12561%, 73.094177%)",
    offset: 0.757813
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(37.809753%, 13.104248%, 73.402405%)",
    offset: 0.761719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.174438%, 13.082886%, 73.712158%)",
    offset: 0.765625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.539124%, 13.061523%, 74.021912%)",
    offset: 0.769531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(38.905334%, 13.040161%, 74.331665%)",
    offset: 0.773438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.27002%, 13.018799%, 74.639893%)",
    offset: 0.777344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(39.63623%, 12.997437%, 74.949646%)",
    offset: 0.78125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.000916%, 12.976074%, 75.259399%)",
    offset: 0.785156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.367126%, 12.954712%, 75.569153%)",
    offset: 0.789063
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(40.731812%, 12.931824%, 75.87738%)",
    offset: 0.792969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.096497%, 12.910461%, 76.187134%)",
    offset: 0.796875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.461182%, 12.889099%, 76.496887%)",
    offset: 0.800781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(41.827393%, 12.867737%, 76.806641%)",
    offset: 0.804688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.192078%, 12.846375%, 77.116394%)",
    offset: 0.808594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.558289%, 12.825012%, 77.426147%)",
    offset: 0.8125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(42.922974%, 12.80365%, 77.734375%)",
    offset: 0.816406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.289185%, 12.782288%, 78.044128%)",
    offset: 0.820312
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(43.65387%, 12.760925%, 78.353882%)",
    offset: 0.824219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.018555%, 12.739563%, 78.663635%)",
    offset: 0.828125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.38324%, 12.718201%, 78.971863%)",
    offset: 0.832031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(44.749451%, 12.696838%, 79.281616%)",
    offset: 0.835938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.114136%, 12.67395%, 79.59137%)",
    offset: 0.839844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.480347%, 12.652588%, 79.901123%)",
    offset: 0.84375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(45.845032%, 12.631226%, 80.209351%)",
    offset: 0.847656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.209717%, 12.609863%, 80.519104%)",
    offset: 0.851562
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.574402%, 12.588501%, 80.828857%)",
    offset: 0.855469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(46.940613%, 12.567139%, 81.138611%)",
    offset: 0.859375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.305298%, 12.545776%, 81.446838%)",
    offset: 0.863281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(47.671509%, 12.524414%, 81.756592%)",
    offset: 0.867188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.036194%, 12.503052%, 82.066345%)",
    offset: 0.871094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.402405%, 12.481689%, 82.376099%)",
    offset: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.76709%, 12.460327%, 82.684326%)",
    offset: 0.878906
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.131775%, 12.438965%, 82.99408%)",
    offset: 0.882812
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.49646%, 12.417603%, 83.303833%)",
    offset: 0.886719
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(49.862671%, 12.39624%, 83.613586%)",
    offset: 0.890625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.227356%, 12.373352%, 83.921814%)",
    offset: 0.894531
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.593567%, 12.35199%, 84.231567%)",
    offset: 0.898438
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(50.958252%, 12.330627%, 84.541321%)",
    offset: 0.902344
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.324463%, 12.309265%, 84.851074%)",
    offset: 0.90625
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(51.689148%, 12.287903%, 85.159302%)",
    offset: 0.910156
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.053833%, 12.266541%, 85.469055%)",
    offset: 0.914062
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.418518%, 12.245178%, 85.778809%)",
    offset: 0.917969
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(52.784729%, 12.223816%, 86.088562%)",
    offset: 0.921875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.149414%, 12.202454%, 86.39679%)",
    offset: 0.925781
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.515625%, 12.181091%, 86.706543%)",
    offset: 0.929688
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(53.88031%, 12.159729%, 87.016296%)",
    offset: 0.933594
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.246521%, 12.138367%, 87.32605%)",
    offset: 0.9375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.611206%, 12.115479%, 87.634277%)",
    offset: 0.941406
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(54.975891%, 12.094116%, 87.944031%)",
    offset: 0.945313
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.340576%, 12.072754%, 88.253784%)",
    offset: 0.949219
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(55.706787%, 12.051392%, 88.563538%)",
    offset: 0.953125
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.071472%, 12.030029%, 88.871765%)",
    offset: 0.957031
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.437683%, 12.008667%, 89.181519%)",
    offset: 0.960938
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(56.802368%, 11.987305%, 89.491272%)",
    offset: 0.964844
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.167053%, 11.965942%, 89.801025%)",
    offset: 0.96875
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.531738%, 11.94458%, 90.109253%)",
    offset: 0.972656
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(57.897949%, 11.923218%, 90.419006%)",
    offset: 0.976563
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.262634%, 11.901855%, 90.72876%)",
    offset: 0.980469
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.628845%, 11.880493%, 91.038513%)",
    offset: 0.984375
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(58.99353%, 11.857605%, 91.346741%)",
    offset: 0.988281
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.359741%, 11.836243%, 91.656494%)",
    offset: 0.992188
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.67865%, 11.817932%, 91.928101%)",
    offset: 0.996094
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(59.999084%, 11.799622%, 92.199707%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a7f663e4e2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 84 18.046875 L 121 18.046875 L 121 49.316406 L 84 49.316406 Z M 84 18.046875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "59ad66b149"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 119.703125 29.414062 C 119.542969 22 114.351562 18.078125 107.996094 18.078125 C 104.511719 18.078125 101.363281 19.261719 99.222656 21.558594 C 97.082031 19.261719 93.9375 18.078125 90.449219 18.078125 C 84.09375 18.078125 78.90625 22.015625 78.742188 29.429688 C 78.742188 29.449219 78.742188 29.464844 78.742188 29.480469 L 78.742188 46.394531 C 78.742188 47.953125 79.992188 49.199219 81.515625 49.199219 L 84.144531 49.199219 C 84.402344 49.199219 84.613281 48.988281 84.613281 48.722656 L 84.613281 29.464844 C 84.726562 25.804688 87.289062 23.871094 90.449219 23.871094 C 93.613281 23.871094 96.175781 25.804688 96.289062 29.464844 L 96.289062 46.378906 C 96.289062 47.9375 97.539062 49.183594 99.0625 49.183594 L 101.6875 49.183594 C 101.949219 49.183594 102.160156 48.96875 102.160156 48.707031 L 102.160156 29.449219 C 102.273438 25.789062 104.835938 23.855469 107.996094 23.855469 C 111.160156 23.855469 113.722656 25.789062 113.835938 29.449219 L 113.835938 46.363281 C 113.835938 47.921875 115.082031 49.167969 116.609375 49.167969 L 119.234375 49.167969 C 119.492188 49.167969 119.703125 48.953125 119.703125 48.691406 L 119.703125 29.429688 C 119.722656 29.449219 119.703125 29.429688 119.703125 29.414062 Z M 178.84375 18.554688 L 174.386719 18.554688 C 173.152344 18.554688 172 19.179688 171.304688 20.210938 L 166.375 27.59375 C 165.726562 28.5625 164.332031 28.5625 163.683594 27.59375 L 158.753906 20.210938 C 158.070312 19.179688 156.902344 18.554688 155.671875 18.554688 L 151.210938 18.554688 C 150.9375 18.554688 150.773438 18.867188 150.921875 19.097656 L 159.710938 32.285156 C 160.34375 33.238281 160.34375 34.484375 159.710938 35.4375 L 150.921875 48.625 C 150.757812 48.855469 150.9375 49.167969 151.210938 49.167969 L 155.671875 49.167969 C 156.902344 49.167969 158.054688 48.542969 158.753906 47.511719 L 163.683594 40.128906 C 164.332031 39.160156 165.726562 39.160156 166.375 40.128906 L 171.304688 47.511719 C 171.984375 48.542969 173.152344 49.167969 174.386719 49.167969 L 178.84375 49.167969 C 179.121094 49.167969 179.28125 48.855469 179.136719 48.625 L 170.332031 35.453125 C 169.699219 34.5 169.699219 33.253906 170.332031 32.300781 L 179.121094 19.113281 C 179.28125 18.882812 179.121094 18.554688 178.84375 18.554688 Z M 148.910156 18.554688 L 146.28125 18.554688 C 144.953125 18.554688 143.835938 19.507812 143.558594 20.769531 C 141.222656 18.964844 138.289062 18.046875 135.125 18.046875 C 127.441406 18.046875 121.195312 23.460938 121.195312 33.679688 C 121.195312 43.902344 127.421875 49.316406 135.125 49.316406 C 138.273438 49.316406 141.175781 48.414062 143.507812 46.640625 C 143.640625 48.066406 144.824219 49.199219 146.28125 49.199219 L 148.910156 49.199219 C 149.167969 49.199219 149.378906 48.988281 149.378906 48.722656 L 149.378906 19.03125 C 149.363281 18.769531 149.167969 18.554688 148.910156 18.554688 Z M 135.125 43.507812 C 130.535156 43.507812 126.808594 40.113281 126.808594 33.695312 C 126.808594 27.28125 130.535156 23.886719 135.125 23.886719 C 139.714844 23.886719 143.445312 27.28125 143.445312 33.695312 C 143.445312 40.113281 139.714844 43.507812 135.125 43.507812 Z M 135.125 43.507812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c6d139a629"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 120.855469 27.9375 C 120.855469 28.710938 120.828125 29.484375 120.769531 30.253906 C 120.710938 31.023438 120.625 31.789062 120.511719 32.546875 C 120.398438 33.304688 120.253906 34.054688 120.082031 34.796875 C 119.914062 35.535156 119.714844 36.265625 119.492188 36.980469 C 119.265625 37.695312 119.015625 38.390625 118.738281 39.074219 C 118.460938 39.757812 118.160156 40.417969 117.832031 41.0625 C 117.507812 41.707031 117.15625 42.328125 116.785156 42.925781 C 116.414062 43.523438 116.019531 44.097656 115.601562 44.644531 C 115.1875 45.191406 114.753906 45.710938 114.300781 46.199219 C 113.84375 46.691406 113.375 47.152344 112.886719 47.582031 C 112.398438 48.011719 111.894531 48.40625 111.375 48.773438 C 110.855469 49.136719 110.328125 49.46875 109.785156 49.765625 C 109.242188 50.058594 108.6875 50.320312 108.128906 50.546875 C 107.566406 50.769531 106.996094 50.957031 106.417969 51.109375 C 105.84375 51.257812 105.261719 51.371094 104.679688 51.449219 C 104.09375 51.523438 103.507812 51.5625 102.921875 51.5625 C 102.332031 51.5625 101.746094 51.523438 101.164062 51.449219 C 100.578125 51.371094 100 51.257812 99.421875 51.109375 C 98.847656 50.957031 98.277344 50.769531 97.714844 50.546875 C 97.152344 50.320312 96.601562 50.058594 96.058594 49.765625 C 95.515625 49.46875 94.984375 49.136719 94.464844 48.773438 C 93.949219 48.40625 93.445312 48.011719 92.957031 47.582031 C 92.46875 47.152344 91.996094 46.691406 91.542969 46.199219 C 91.089844 45.710938 90.65625 45.191406 90.238281 44.644531 C 89.824219 44.097656 89.429688 43.523438 89.058594 42.925781 C 88.683594 42.328125 88.335938 41.707031 88.007812 41.0625 C 87.683594 40.417969 87.378906 39.757812 87.105469 39.074219 C 86.828125 38.390625 86.578125 37.695312 86.351562 36.980469 C 86.125 36.265625 85.929688 35.535156 85.757812 34.796875 C 85.585938 34.054688 85.445312 33.304688 85.332031 32.546875 C 85.214844 31.789062 85.128906 31.023438 85.074219 30.253906 C 85.015625 29.484375 84.984375 28.710938 84.984375 27.9375 C 84.984375 27.164062 85.015625 26.394531 85.074219 25.625 C 85.128906 24.851562 85.214844 24.089844 85.332031 23.328125 C 85.445312 22.570312 85.585938 21.820312 85.757812 21.082031 C 85.929688 20.339844 86.125 19.613281 86.351562 18.898438 C 86.578125 18.183594 86.828125 17.484375 87.105469 16.800781 C 87.378906 16.121094 87.683594 15.457031 88.007812 14.8125 C 88.335938 14.171875 88.683594 13.550781 89.058594 12.953125 C 89.429688 12.355469 89.824219 11.78125 90.238281 11.234375 C 90.65625 10.6875 91.089844 10.167969 91.542969 9.675781 C 91.996094 9.1875 92.46875 8.726562 92.957031 8.296875 C 93.445312 7.867188 93.949219 7.46875 94.464844 7.105469 C 94.984375 6.738281 95.515625 6.410156 96.058594 6.113281 C 96.601562 5.816406 97.152344 5.558594 97.714844 5.332031 C 98.277344 5.109375 98.847656 4.921875 99.421875 4.769531 C 100 4.617188 100.578125 4.503906 101.164062 4.429688 C 101.746094 4.351562 102.332031 4.316406 102.921875 4.316406 C 103.507812 4.316406 104.09375 4.351562 104.679688 4.429688 C 105.261719 4.503906 105.84375 4.617188 106.421875 4.769531 C 106.996094 4.921875 107.566406 5.109375 108.128906 5.332031 C 108.6875 5.558594 109.242188 5.816406 109.785156 6.113281 C 110.328125 6.410156 110.859375 6.738281 111.375 7.105469 C 111.894531 7.46875 112.398438 7.867188 112.886719 8.296875 C 113.375 8.726562 113.84375 9.1875 114.296875 9.675781 C 114.753906 10.167969 115.1875 10.6875 115.601562 11.234375 C 116.019531 11.78125 116.414062 12.355469 116.785156 12.953125 C 117.15625 13.550781 117.507812 14.171875 117.832031 14.8125 C 118.160156 15.457031 118.460938 16.121094 118.738281 16.800781 C 119.015625 17.484375 119.265625 18.183594 119.492188 18.898438 C 119.714844 19.613281 119.914062 20.339844 120.082031 21.082031 C 120.253906 21.820312 120.398438 22.570312 120.511719 23.328125 C 120.625 24.089844 120.710938 24.851562 120.769531 25.625 C 120.828125 26.394531 120.855469 27.164062 120.855469 27.9375 Z M 120.855469 27.9375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 102,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGYAAAAgCAYAAADg3g0TAAAABmJLR0QA/wD/AP+gvaeTAAACdElEQVRoge2a246DMAxEByj//8Fbln1oRhgzuUG1D5iRLNqqhTan49gJA76nKcWYYkhhtab4TbGk4/rF73ELvb5wjhEbFAWGcFYcwYz4wCGgR0lXwUzpHFfAMN74AHqEa2AmADOOcOxgq1T2Cw2GEN8XvtNtdBYMobxM5MDkHLNAA1zxOOcUmBF7IB4O55xaKiulPCA4nF4wA/Ygaq4ppbIWV4Wt1nrBcD4pRa5kVhO/L6lXFz+9P+gu6gHDFKbgzNg7hnDOgvF9Tjj1gJlE5Byj0pkf8FLz+UrHCQ+YomwT+RJH5RoFhhVXrhrzUCYEdU0PmByckmtUKssBU1AI+AGTkepRculsxnGeAXSZzNdtmvNQJgRsOlvAKBi5ucaWzyUwNbeMIkK5phdMKyBGCxjCWNz57fEBI8SBrAGy8w6dw/cBW6pSUNQiqL9uKLWAKUFRcFSzCWxlMqChqGvk9nVurxqYQYT6N6tigEWABcPHHkwOhr9mmHR2BowfLOUk7xpgayotlBqQAUFdcwVMDZLdrwGOzinB8CvO4dSzJNMDyM4ds/m87/p7I4x6HNMiD4lpbcBx4TL0wNf0X2Vo2H2Vs6o5xu6NtEgt23M5xd6qlItHST1zTGlAPRAPBdjAMFrOFxZcj2NaYFgoLI/Z7RPUFUBhdAWMHVgPZcQHApf5gb2L7E1+C+qQwqkXjP+n24HlYL+xVVi227dgPBwfueuGUcsck3PH4h5bKLbD53O+940jnBwgCymUWsCodOWBeCjAHox9rqC0AAqlVjAlIISi7opRey82nSnX5ACFUisYP2g+ONlTPo3xtRV7mKWU5uGE0h/Qkof5UvDbMAAAAABJRU5ErkJggg==",
    id: "eed1cf56ab",
    height: 32,
    preserveAspectRatio: "xMidYMid meet"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "559bcfb78b"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#1b9a2d95c7)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 102,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGYAAAAgCAYAAADg3g0TAAAABmJLR0QA/wD/AP+gvaeTAAACdElEQVRoge2a246DMAxEByj//8Fbln1oRhgzuUG1D5iRLNqqhTan49gJA76nKcWYYkhhtab4TbGk4/rF73ELvb5wjhEbFAWGcFYcwYz4wCGgR0lXwUzpHFfAMN74AHqEa2AmADOOcOxgq1T2Cw2GEN8XvtNtdBYMobxM5MDkHLNAA1zxOOcUmBF7IB4O55xaKiulPCA4nF4wA/Ygaq4ppbIWV4Wt1nrBcD4pRa5kVhO/L6lXFz+9P+gu6gHDFKbgzNg7hnDOgvF9Tjj1gJlE5Byj0pkf8FLz+UrHCQ+YomwT+RJH5RoFhhVXrhrzUCYEdU0PmByckmtUKssBU1AI+AGTkepRculsxnGeAXSZzNdtmvNQJgRsOlvAKBi5ucaWzyUwNbeMIkK5phdMKyBGCxjCWNz57fEBI8SBrAGy8w6dw/cBW6pSUNQiqL9uKLWAKUFRcFSzCWxlMqChqGvk9nVurxqYQYT6N6tigEWABcPHHkwOhr9mmHR2BowfLOUk7xpgayotlBqQAUFdcwVMDZLdrwGOzinB8CvO4dSzJNMDyM4ds/m87/p7I4x6HNMiD4lpbcBx4TL0wNf0X2Vo2H2Vs6o5xu6NtEgt23M5xd6qlItHST1zTGlAPRAPBdjAMFrOFxZcj2NaYFgoLI/Z7RPUFUBhdAWMHVgPZcQHApf5gb2L7E1+C+qQwqkXjP+n24HlYL+xVVi227dgPBwfueuGUcsck3PH4h5bKLbD53O+940jnBwgCymUWsCodOWBeCjAHox9rqC0AAqlVjAlIISi7opRey82nSnX5ACFUisYP2g+ONlTPo3xtRV7mKWU5uGE0h/Qkof5UvDbMAAAAABJRU5ErkJggg==",
    height: 32,
    preserveAspectRatio: "xMidYMid meet"
  })))), /*#__PURE__*/React.createElement("radialGradient", {
    gradientTransform: "matrix(0.863195, 0, 0, -1.136805, -139.028717, -17.986198)",
    gradientUnits: "userSpaceOnUse",
    r: 20.930214,
    cx: 190.052833,
    id: "7d6f690c07",
    cy: -35.157039,
    fx: 190.052833,
    fy: -35.157039
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.199463%, 65.499878%, 94.898987%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.199463%, 65.499878%, 94.898987%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "abf17fc990"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 102,
    y: 0,
    height: 32
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "67bdaaf0c7",
    patternUnits: "userSpaceOnUse",
    width: 102,
    patternTransform: "matrix(0.992647, 0, 0, -0.992647, 78.088236, 49.751464)",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 102 32",
    height: 32,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#abf17fc990)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#559bcfb78b)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -118.560004,
    fill: "url(#7d6f690c07)",
    width: 261.120008,
    height: 97.92,
    y: -32.840005
  }))))), /*#__PURE__*/React.createElement("clipPath", {
    id: "389b0e8da8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 83 21 L 158 21 L 158 49.316406 L 83 49.316406 Z M 83 21 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c1c083a194"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 119.703125 29.414062 C 119.542969 22 114.351562 18.078125 107.996094 18.078125 C 104.511719 18.078125 101.363281 19.261719 99.222656 21.558594 C 97.082031 19.261719 93.9375 18.078125 90.449219 18.078125 C 84.09375 18.078125 78.90625 22.015625 78.742188 29.429688 C 78.742188 29.449219 78.742188 29.464844 78.742188 29.480469 L 78.742188 46.394531 C 78.742188 47.953125 79.992188 49.199219 81.515625 49.199219 L 84.144531 49.199219 C 84.402344 49.199219 84.613281 48.988281 84.613281 48.722656 L 84.613281 29.464844 C 84.726562 25.804688 87.289062 23.871094 90.449219 23.871094 C 93.613281 23.871094 96.175781 25.804688 96.289062 29.464844 L 96.289062 46.378906 C 96.289062 47.9375 97.539062 49.183594 99.0625 49.183594 L 101.6875 49.183594 C 101.949219 49.183594 102.160156 48.96875 102.160156 48.707031 L 102.160156 29.449219 C 102.273438 25.789062 104.835938 23.855469 107.996094 23.855469 C 111.160156 23.855469 113.722656 25.789062 113.835938 29.449219 L 113.835938 46.363281 C 113.835938 47.921875 115.082031 49.167969 116.609375 49.167969 L 119.234375 49.167969 C 119.492188 49.167969 119.703125 48.953125 119.703125 48.691406 L 119.703125 29.429688 C 119.722656 29.449219 119.703125 29.429688 119.703125 29.414062 Z M 178.84375 18.554688 L 174.386719 18.554688 C 173.152344 18.554688 172 19.179688 171.304688 20.210938 L 166.375 27.59375 C 165.726562 28.5625 164.332031 28.5625 163.683594 27.59375 L 158.753906 20.210938 C 158.070312 19.179688 156.902344 18.554688 155.671875 18.554688 L 151.210938 18.554688 C 150.9375 18.554688 150.773438 18.867188 150.921875 19.097656 L 159.710938 32.285156 C 160.34375 33.238281 160.34375 34.484375 159.710938 35.4375 L 150.921875 48.625 C 150.757812 48.855469 150.9375 49.167969 151.210938 49.167969 L 155.671875 49.167969 C 156.902344 49.167969 158.054688 48.542969 158.753906 47.511719 L 163.683594 40.128906 C 164.332031 39.160156 165.726562 39.160156 166.375 40.128906 L 171.304688 47.511719 C 171.984375 48.542969 173.152344 49.167969 174.386719 49.167969 L 178.84375 49.167969 C 179.121094 49.167969 179.28125 48.855469 179.136719 48.625 L 170.332031 35.453125 C 169.699219 34.5 169.699219 33.253906 170.332031 32.300781 L 179.121094 19.113281 C 179.28125 18.882812 179.121094 18.554688 178.84375 18.554688 Z M 148.910156 18.554688 L 146.28125 18.554688 C 144.953125 18.554688 143.835938 19.507812 143.558594 20.769531 C 141.222656 18.964844 138.289062 18.046875 135.125 18.046875 C 127.441406 18.046875 121.195312 23.460938 121.195312 33.679688 C 121.195312 43.902344 127.421875 49.316406 135.125 49.316406 C 138.273438 49.316406 141.175781 48.414062 143.507812 46.640625 C 143.640625 48.066406 144.824219 49.199219 146.28125 49.199219 L 148.910156 49.199219 C 149.167969 49.199219 149.378906 48.988281 149.378906 48.722656 L 149.378906 19.03125 C 149.363281 18.769531 149.167969 18.554688 148.910156 18.554688 Z M 135.125 43.507812 C 130.535156 43.507812 126.808594 40.113281 126.808594 33.695312 C 126.808594 27.28125 130.535156 23.886719 135.125 23.886719 C 139.714844 23.886719 143.445312 27.28125 143.445312 33.695312 C 143.445312 40.113281 139.714844 43.507812 135.125 43.507812 Z M 135.125 43.507812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3296c7ad43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 157.699219 47.625 C 157.699219 48.492188 157.640625 49.355469 157.519531 50.214844 C 157.402344 51.078125 157.226562 51.933594 156.988281 52.78125 C 156.753906 53.628906 156.460938 54.46875 156.109375 55.296875 C 155.757812 56.125 155.351562 56.9375 154.890625 57.738281 C 154.425781 58.539062 153.910156 59.320312 153.339844 60.082031 C 152.769531 60.847656 152.148438 61.589844 151.480469 62.308594 C 150.808594 63.027344 150.089844 63.722656 149.320312 64.390625 C 148.554688 65.058594 147.742188 65.699219 146.890625 66.3125 C 146.035156 66.925781 145.140625 67.503906 144.207031 68.054688 C 143.269531 68.605469 142.300781 69.117188 141.296875 69.601562 C 140.289062 70.082031 139.253906 70.523438 138.1875 70.933594 C 137.125 71.339844 136.03125 71.710938 134.914062 72.042969 C 133.796875 72.375 132.660156 72.664062 131.503906 72.914062 C 130.347656 73.167969 129.175781 73.378906 127.992188 73.546875 C 126.804688 73.714844 125.613281 73.839844 124.410156 73.925781 C 123.207031 74.011719 122 74.054688 120.792969 74.054688 C 119.582031 74.054688 118.375 74.011719 117.171875 73.925781 C 115.96875 73.839844 114.777344 73.714844 113.589844 73.546875 C 112.40625 73.378906 111.234375 73.167969 110.078125 72.914062 C 108.921875 72.664062 107.785156 72.375 106.667969 72.042969 C 105.550781 71.710938 104.457031 71.339844 103.394531 70.933594 C 102.328125 70.523438 101.292969 70.082031 100.285156 69.601562 C 99.28125 69.117188 98.3125 68.605469 97.378906 68.054688 C 96.441406 67.503906 95.546875 66.925781 94.695312 66.3125 C 93.839844 65.699219 93.027344 65.058594 92.261719 64.390625 C 91.496094 63.722656 90.773438 63.027344 90.105469 62.308594 C 89.433594 61.589844 88.8125 60.847656 88.242188 60.082031 C 87.671875 59.320312 87.15625 58.539062 86.691406 57.738281 C 86.230469 56.9375 85.824219 56.125 85.472656 55.296875 C 85.121094 54.46875 84.828125 53.628906 84.59375 52.78125 C 84.355469 51.933594 84.179688 51.078125 84.0625 50.214844 C 83.941406 49.355469 83.882812 48.492188 83.882812 47.625 C 83.882812 46.757812 83.941406 45.894531 84.0625 45.035156 C 84.179688 44.171875 84.355469 43.316406 84.59375 42.46875 C 84.828125 41.621094 85.121094 40.78125 85.472656 39.953125 C 85.824219 39.125 86.230469 38.3125 86.691406 37.511719 C 87.15625 36.710938 87.671875 35.929688 88.242188 35.167969 C 88.8125 34.402344 89.433594 33.660156 90.101562 32.941406 C 90.773438 32.222656 91.496094 31.527344 92.261719 30.859375 C 93.027344 30.191406 93.839844 29.550781 94.695312 28.9375 C 95.546875 28.324219 96.441406 27.746094 97.378906 27.195312 C 98.3125 26.644531 99.28125 26.132812 100.285156 25.648438 C 101.292969 25.167969 102.328125 24.726562 103.394531 24.316406 C 104.457031 23.910156 105.550781 23.539062 106.667969 23.207031 C 107.785156 22.875 108.921875 22.585938 110.078125 22.335938 C 111.234375 22.082031 112.40625 21.871094 113.589844 21.703125 C 114.777344 21.535156 115.96875 21.410156 117.171875 21.324219 C 118.375 21.238281 119.582031 21.195312 120.792969 21.195312 C 122 21.195312 123.207031 21.238281 124.410156 21.324219 C 125.613281 21.410156 126.804688 21.535156 127.992188 21.703125 C 129.175781 21.871094 130.347656 22.082031 131.503906 22.335938 C 132.660156 22.585938 133.796875 22.875 134.914062 23.207031 C 136.03125 23.539062 137.125 23.910156 138.1875 24.316406 C 139.253906 24.726562 140.289062 25.167969 141.296875 25.648438 C 142.300781 26.132812 143.269531 26.644531 144.203125 27.195312 C 145.140625 27.746094 146.035156 28.324219 146.890625 28.9375 C 147.742188 29.550781 148.554688 30.191406 149.320312 30.859375 C 150.089844 31.527344 150.808594 32.222656 151.480469 32.941406 C 152.148438 33.660156 152.769531 34.402344 153.339844 35.167969 C 153.910156 35.929688 154.425781 36.710938 154.890625 37.511719 C 155.351562 38.3125 155.757812 39.125 156.109375 39.953125 C 156.460938 40.78125 156.753906 41.621094 156.988281 42.46875 C 157.226562 43.316406 157.402344 44.171875 157.519531 45.035156 C 157.640625 45.894531 157.699219 46.757812 157.699219 47.625 Z M 157.699219 47.625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 102,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGYAAAAgCAYAAADg3g0TAAAABmJLR0QA/wD/AP+gvaeTAAADk0lEQVRoge2a4W7qMAyFD1Cm3fd/2A0K7X60Vo05dhxoClfiSFHQytI0X4/thu7gqwPwb27fyb7mu9/O3w4AdsG8mEYAVwC/AH7mXn9eo/eO9ZVzTWkfHNthWSDWsxYds23vtFoock42jtdHLbpedqyJIjCt1PSCkFu4FsdWVQnM6PTRsTFxjLXB/G+N2DgD4vM9On+Qz6srAlO6qFIbCu1K2uWJa7nMTcYaVK8bg1cDk4FbXV1wzE5STz6z6PazXnwNo8eU8A9YcsAR+bAxzmOe57F63EOyzYP2CMQmisBYCBEUu/jMCbpZGDbpj1jgeIDkhukxQTlhgaMhWVgRNO+miloTZcDYRY/CUASDAbELr8/Zz/PrcB9yBzPuOWgemBIk77rtzdpEERiQyXlOqHGGdohAkbtfj9PhHqJ814ZGWXyBcUIMKQLlXRtrzZQBU+sEC0IvrAZiiwQ9tjhFxipBZHAiSF64s/mp5KxmKoGRBYjCQI077F2v7/4LprxyBHeLBeO5xnPPCWUn2XGi621aLpfAwJmUdUjJHSJWSl8AfM1jCpQO94UBA2OdlnGOBdSTPgOnqTJgBnAQzB1sewO4L7lZaOxMk3MIZDsnGUfgSsFg4diqTcPJuIi1ZtWYKAMGKIcpFq5E7KFTQ9HhS4cwr5SGMxbLN1n3eIB68HDXXFkwwDSpCIiVB8MC0VBsbsmAsaA1HP3gmXVPqVhomltENWCumCYXuUPk7RSwO1sne51bdBjzXFhyjRfWMu5hkJpWYlo1YIDpQk/BcZbc2aJ5TtG5hSX+zHlYoRKFtSygTUKYqBYMwH8YivbTovB1xK1TooLCO5+3KcpcE7nHC2/y3U31CBjgdqJRctd3sC6JvbzCkn5tQRHlm1JYY+7ZHArwOBhgSYTRlr4A0SWxhZJxSwaMd0Nkwprnnk3Dl9YzYIBp4h4QL6fY0tirxGrA6Gcabw41Ye2MDZ5VIq35U+kRkzu+cJtLvLLYq8RsOe7Nk+U0Dcfb79LPI/r5RLvn5Vr7N+w9FkDMJaw0jsJY9HJGqdhgzulJr13zUpdotXq54AA/fEUJP9pr03tl0rPN0FIhwMBs9nySVeu3PsQZrHlQngHjwdHb9nZr/y211es4O8QJP5P4PTCsMiwVAptsqzyjzd6TMudkT/leGMuCYeFMFwJvD0PrFWCsvLcxa8B4z1P/rd4BTKQMmI8++uijj95Tf6lQ8Vj0Bv9bAAAAAElFTkSuQmCC",
    id: "cf535db293",
    height: 32,
    preserveAspectRatio: "xMidYMid meet"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "26e6268bff"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#1b9a2d95c7)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 102,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGYAAAAgCAYAAADg3g0TAAAABmJLR0QA/wD/AP+gvaeTAAADk0lEQVRoge2a4W7qMAyFD1Cm3fd/2A0K7X60Vo05dhxoClfiSFHQytI0X4/thu7gqwPwb27fyb7mu9/O3w4AdsG8mEYAVwC/AH7mXn9eo/eO9ZVzTWkfHNthWSDWsxYds23vtFoock42jtdHLbpedqyJIjCt1PSCkFu4FsdWVQnM6PTRsTFxjLXB/G+N2DgD4vM9On+Qz6srAlO6qFIbCu1K2uWJa7nMTcYaVK8bg1cDk4FbXV1wzE5STz6z6PazXnwNo8eU8A9YcsAR+bAxzmOe57F63EOyzYP2CMQmisBYCBEUu/jMCbpZGDbpj1jgeIDkhukxQTlhgaMhWVgRNO+miloTZcDYRY/CUASDAbELr8/Zz/PrcB9yBzPuOWgemBIk77rtzdpEERiQyXlOqHGGdohAkbtfj9PhHqJ814ZGWXyBcUIMKQLlXRtrzZQBU+sEC0IvrAZiiwQ9tjhFxipBZHAiSF64s/mp5KxmKoGRBYjCQI077F2v7/4LprxyBHeLBeO5xnPPCWUn2XGi621aLpfAwJmUdUjJHSJWSl8AfM1jCpQO94UBA2OdlnGOBdSTPgOnqTJgBnAQzB1sewO4L7lZaOxMk3MIZDsnGUfgSsFg4diqTcPJuIi1ZtWYKAMGKIcpFq5E7KFTQ9HhS4cwr5SGMxbLN1n3eIB68HDXXFkwwDSpCIiVB8MC0VBsbsmAsaA1HP3gmXVPqVhomltENWCumCYXuUPk7RSwO1sne51bdBjzXFhyjRfWMu5hkJpWYlo1YIDpQk/BcZbc2aJ5TtG5hSX+zHlYoRKFtSygTUKYqBYMwH8YivbTovB1xK1TooLCO5+3KcpcE7nHC2/y3U31CBjgdqJRctd3sC6JvbzCkn5tQRHlm1JYY+7ZHArwOBhgSYTRlr4A0SWxhZJxSwaMd0Nkwprnnk3Dl9YzYIBp4h4QL6fY0tirxGrA6Gcabw41Ye2MDZ5VIq35U+kRkzu+cJtLvLLYq8RsOe7Nk+U0Dcfb79LPI/r5RLvn5Vr7N+w9FkDMJaw0jsJY9HJGqdhgzulJr13zUpdotXq54AA/fEUJP9pr03tl0rPN0FIhwMBs9nySVeu3PsQZrHlQngHjwdHb9nZr/y211es4O8QJP5P4PTCsMiwVAptsqzyjzd6TMudkT/leGMuCYeFMFwJvD0PrFWCsvLcxa8B4z1P/rd4BTKQMmI8++uijj95Tf6lQ8Vj0Bv9bAAAAAElFTkSuQmCC",
    height: 32,
    preserveAspectRatio: "xMidYMid meet"
  })))), /*#__PURE__*/React.createElement("radialGradient", {
    gradientTransform: "matrix(1.165256, 0, 0, -0.834744, -502.5914, -43.111645)",
    gradientUnits: "userSpaceOnUse",
    r: 31.902174,
    cx: 468.226691,
    id: "c658a45a1b",
    cy: -54.218752,
    fx: 468.226691,
    fy: -54.218752
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.199463%, 65.499878%, 94.898987%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.199463%, 65.499878%, 94.898987%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a59f4de610"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 102,
    y: 0,
    height: 32
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "bbd02f1cf6",
    patternUnits: "userSpaceOnUse",
    width: 102,
    patternTransform: "matrix(0.992647, 0, 0, -0.992647, 78.088236, 49.751464)",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 102 32",
    height: 32,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a59f4de610)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#26e6268bff)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -118.560004,
    fill: "url(#c658a45a1b)",
    width: 261.120008,
    height: 97.92,
    y: -32.840005
  }))))), /*#__PURE__*/React.createElement("clipPath", {
    id: "d76e3b230c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 123 18.046875 L 164 18.046875 L 164 41 L 123 41 Z M 123 18.046875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "46bcba62cd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 119.703125 29.414062 C 119.542969 22 114.351562 18.078125 107.996094 18.078125 C 104.511719 18.078125 101.363281 19.261719 99.222656 21.558594 C 97.082031 19.261719 93.9375 18.078125 90.449219 18.078125 C 84.09375 18.078125 78.90625 22.015625 78.742188 29.429688 C 78.742188 29.449219 78.742188 29.464844 78.742188 29.480469 L 78.742188 46.394531 C 78.742188 47.953125 79.992188 49.199219 81.515625 49.199219 L 84.144531 49.199219 C 84.402344 49.199219 84.613281 48.988281 84.613281 48.722656 L 84.613281 29.464844 C 84.726562 25.804688 87.289062 23.871094 90.449219 23.871094 C 93.613281 23.871094 96.175781 25.804688 96.289062 29.464844 L 96.289062 46.378906 C 96.289062 47.9375 97.539062 49.183594 99.0625 49.183594 L 101.6875 49.183594 C 101.949219 49.183594 102.160156 48.96875 102.160156 48.707031 L 102.160156 29.449219 C 102.273438 25.789062 104.835938 23.855469 107.996094 23.855469 C 111.160156 23.855469 113.722656 25.789062 113.835938 29.449219 L 113.835938 46.363281 C 113.835938 47.921875 115.082031 49.167969 116.609375 49.167969 L 119.234375 49.167969 C 119.492188 49.167969 119.703125 48.953125 119.703125 48.691406 L 119.703125 29.429688 C 119.722656 29.449219 119.703125 29.429688 119.703125 29.414062 Z M 178.84375 18.554688 L 174.386719 18.554688 C 173.152344 18.554688 172 19.179688 171.304688 20.210938 L 166.375 27.59375 C 165.726562 28.5625 164.332031 28.5625 163.683594 27.59375 L 158.753906 20.210938 C 158.070312 19.179688 156.902344 18.554688 155.671875 18.554688 L 151.210938 18.554688 C 150.9375 18.554688 150.773438 18.867188 150.921875 19.097656 L 159.710938 32.285156 C 160.34375 33.238281 160.34375 34.484375 159.710938 35.4375 L 150.921875 48.625 C 150.757812 48.855469 150.9375 49.167969 151.210938 49.167969 L 155.671875 49.167969 C 156.902344 49.167969 158.054688 48.542969 158.753906 47.511719 L 163.683594 40.128906 C 164.332031 39.160156 165.726562 39.160156 166.375 40.128906 L 171.304688 47.511719 C 171.984375 48.542969 173.152344 49.167969 174.386719 49.167969 L 178.84375 49.167969 C 179.121094 49.167969 179.28125 48.855469 179.136719 48.625 L 170.332031 35.453125 C 169.699219 34.5 169.699219 33.253906 170.332031 32.300781 L 179.121094 19.113281 C 179.28125 18.882812 179.121094 18.554688 178.84375 18.554688 Z M 148.910156 18.554688 L 146.28125 18.554688 C 144.953125 18.554688 143.835938 19.507812 143.558594 20.769531 C 141.222656 18.964844 138.289062 18.046875 135.125 18.046875 C 127.441406 18.046875 121.195312 23.460938 121.195312 33.679688 C 121.195312 43.902344 127.421875 49.316406 135.125 49.316406 C 138.273438 49.316406 141.175781 48.414062 143.507812 46.640625 C 143.640625 48.066406 144.824219 49.199219 146.28125 49.199219 L 148.910156 49.199219 C 149.167969 49.199219 149.378906 48.988281 149.378906 48.722656 L 149.378906 19.03125 C 149.363281 18.769531 149.167969 18.554688 148.910156 18.554688 Z M 135.125 43.507812 C 130.535156 43.507812 126.808594 40.113281 126.808594 33.695312 C 126.808594 27.28125 130.535156 23.886719 135.125 23.886719 C 139.714844 23.886719 143.445312 27.28125 143.445312 33.695312 C 143.445312 40.113281 139.714844 43.507812 135.125 43.507812 Z M 135.125 43.507812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "85a71dcb96"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 163.519531 19.835938 C 163.519531 20.5 163.488281 21.164062 163.421875 21.824219 C 163.359375 22.488281 163.261719 23.144531 163.132812 23.796875 C 163.007812 24.449219 162.847656 25.09375 162.65625 25.730469 C 162.464844 26.367188 162.242188 26.992188 161.992188 27.605469 C 161.742188 28.222656 161.460938 28.820312 161.148438 29.410156 C 160.839844 29.996094 160.503906 30.566406 160.136719 31.117188 C 159.773438 31.671875 159.378906 32.203125 158.964844 32.71875 C 158.546875 33.234375 158.105469 33.726562 157.640625 34.195312 C 157.175781 34.664062 156.6875 35.113281 156.179688 35.535156 C 155.671875 35.957031 155.144531 36.351562 154.597656 36.722656 C 154.050781 37.089844 153.488281 37.433594 152.910156 37.746094 C 152.328125 38.058594 151.734375 38.34375 151.128906 38.597656 C 150.519531 38.851562 149.902344 39.078125 149.273438 39.269531 C 148.644531 39.460938 148.007812 39.625 147.363281 39.753906 C 146.714844 39.882812 146.066406 39.980469 145.414062 40.046875 C 144.757812 40.113281 144.101562 40.144531 143.445312 40.144531 C 142.789062 40.144531 142.132812 40.113281 141.476562 40.046875 C 140.824219 39.980469 140.171875 39.882812 139.527344 39.753906 C 138.882812 39.625 138.246094 39.460938 137.617188 39.269531 C 136.988281 39.078125 136.371094 38.851562 135.761719 38.597656 C 135.15625 38.34375 134.5625 38.058594 133.980469 37.746094 C 133.402344 37.433594 132.839844 37.089844 132.292969 36.722656 C 131.746094 36.351562 131.21875 35.957031 130.710938 35.535156 C 130.199219 35.113281 129.714844 34.664062 129.25 34.195312 C 128.785156 33.726562 128.34375 33.234375 127.925781 32.71875 C 127.507812 32.203125 127.117188 31.671875 126.753906 31.117188 C 126.386719 30.566406 126.050781 29.996094 125.738281 29.410156 C 125.429688 28.820312 125.148438 28.222656 124.898438 27.605469 C 124.644531 26.992188 124.425781 26.367188 124.234375 25.730469 C 124.042969 25.09375 123.882812 24.449219 123.753906 23.796875 C 123.628906 23.144531 123.53125 22.488281 123.464844 21.824219 C 123.402344 21.164062 123.371094 20.5 123.371094 19.835938 C 123.371094 19.167969 123.402344 18.503906 123.464844 17.84375 C 123.53125 17.183594 123.628906 16.523438 123.753906 15.871094 C 123.882812 15.21875 124.042969 14.574219 124.234375 13.9375 C 124.425781 13.300781 124.644531 12.675781 124.898438 12.0625 C 125.148438 11.449219 125.429688 10.847656 125.738281 10.261719 C 126.050781 9.675781 126.386719 9.105469 126.753906 8.550781 C 127.117188 7.996094 127.507812 7.464844 127.925781 6.949219 C 128.34375 6.4375 128.785156 5.945312 129.25 5.472656 C 129.714844 5.003906 130.199219 4.558594 130.710938 4.136719 C 131.21875 3.714844 131.746094 3.316406 132.292969 2.949219 C 132.839844 2.578125 133.402344 2.238281 133.980469 1.921875 C 134.5625 1.609375 135.15625 1.324219 135.761719 1.070312 C 136.371094 0.816406 136.988281 0.59375 137.617188 0.398438 C 138.246094 0.207031 138.882812 0.0429688 139.527344 -0.0859375 C 140.171875 -0.214844 140.824219 -0.3125 141.476562 -0.378906 C 142.132812 -0.441406 142.789062 -0.476562 143.445312 -0.476562 C 144.101562 -0.476562 144.757812 -0.441406 145.414062 -0.378906 C 146.066406 -0.3125 146.714844 -0.214844 147.363281 -0.0859375 C 148.007812 0.0429688 148.644531 0.207031 149.273438 0.398438 C 149.902344 0.59375 150.519531 0.816406 151.128906 1.070312 C 151.734375 1.324219 152.328125 1.609375 152.910156 1.921875 C 153.488281 2.238281 154.050781 2.578125 154.597656 2.949219 C 155.144531 3.316406 155.671875 3.714844 156.179688 4.136719 C 156.6875 4.558594 157.175781 5.003906 157.640625 5.472656 C 158.105469 5.945312 158.546875 6.4375 158.964844 6.949219 C 159.378906 7.464844 159.773438 7.996094 160.136719 8.550781 C 160.503906 9.105469 160.839844 9.675781 161.148438 10.261719 C 161.460938 10.847656 161.742188 11.449219 161.992188 12.0625 C 162.242188 12.675781 162.464844 13.300781 162.65625 13.9375 C 162.847656 14.574219 163.007812 15.21875 163.132812 15.871094 C 163.261719 16.523438 163.359375 17.183594 163.421875 17.84375 C 163.488281 18.503906 163.519531 19.167969 163.519531 19.835938 Z M 163.519531 19.835938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 102,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGYAAAAgCAYAAADg3g0TAAAABmJLR0QA/wD/AP+gvaeTAAACZklEQVRoge2Z0XKjMAxFDwRo2v//1t0CadgHrLEQcrotJBkc3xmNMyQE45MryQSKioqKioqKioqKioqKioryVfXsCTxBFXAC6hAVcR0m4Kri6xkThNcC0wBtGDWYWn1mIsL5CnEBRh4M6RXAtEAXRg1G4KQcI1AEzAgMPAhQ84iLPEkn4I0ZigbT8jswQzi3D3FX5QqmBc7MYCychnU6q5ihgJ/GRtaO67mje3IE0wHvLMEIHC+deY6xYAb8+vQZPrO7cgMjUASMhOcam868wq/dkqpNf7iDc3IC0xKhWDiea+wiwwxGu+WC7xbdNE3McK573kwuYE4sHaLBvOOnNL3QInGMLvpeCtMgBebfPW8oFzAdceE9ODal6SZAL7R0ZNYtt+qRTn3DXjeUA5iWpSPOpN2jXeOBkV+/dYu3EU211RM7KAcwnQoPkK45ctymM+0YXfS9uqIbhAtLKB077XGODkYes3T4gFJp7Y1lE+CBGViD89ppSXldGAd2cM3Rweh9SQqQl9YEnICpWRZ+cYttpVMdm44mnL9JRwZTEeuEXZwUIOscXUMgLnrP2km2W7NQGhUvDeZkwoPkpTbbDEi6Ekdot8C6IbgFROayWUcGU7OE8h0oC+iD2KFpMD1+atNALAgbNRs3nEcHY8MDYwHZpuBM/JWP6rW4ZOD/QNh4aTCVGTWgW6AEkKS1jtkhn2G0QCwUD4SdyyYdGQzEnbjekdtjHjQBJX8PfDA7ZGK5f7EQvO9OzWOTjgzGW4CfHtPgJtaLvec1f6Qjg5mc0YurM+rH+r06f2ROY/K+d27qOt6cfq1/sXzchimQET4AAAAASUVORK5CYII=",
    id: "134b8513e0",
    height: 32,
    preserveAspectRatio: "xMidYMid meet"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "f4ebe10690"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#1b9a2d95c7)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    x: 0,
    y: 0,
    width: 102,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGYAAAAgCAYAAADg3g0TAAAABmJLR0QA/wD/AP+gvaeTAAACZklEQVRoge2Z0XKjMAxFDwRo2v//1t0CadgHrLEQcrotJBkc3xmNMyQE45MryQSKioqKioqKioqKioqKioryVfXsCTxBFXAC6hAVcR0m4Kri6xkThNcC0wBtGDWYWn1mIsL5CnEBRh4M6RXAtEAXRg1G4KQcI1AEzAgMPAhQ84iLPEkn4I0ZigbT8jswQzi3D3FX5QqmBc7MYCychnU6q5ihgJ/GRtaO67mje3IE0wHvLMEIHC+deY6xYAb8+vQZPrO7cgMjUASMhOcam868wq/dkqpNf7iDc3IC0xKhWDiea+wiwwxGu+WC7xbdNE3McK573kwuYE4sHaLBvOOnNL3QInGMLvpeCtMgBebfPW8oFzAdceE9ODal6SZAL7R0ZNYtt+qRTn3DXjeUA5iWpSPOpN2jXeOBkV+/dYu3EU211RM7KAcwnQoPkK45ctymM+0YXfS9uqIbhAtLKB077XGODkYes3T4gFJp7Y1lE+CBGViD89ppSXldGAd2cM3Rweh9SQqQl9YEnICpWRZ+cYttpVMdm44mnL9JRwZTEeuEXZwUIOscXUMgLnrP2km2W7NQGhUvDeZkwoPkpTbbDEi6Ekdot8C6IbgFROayWUcGU7OE8h0oC+iD2KFpMD1+atNALAgbNRs3nEcHY8MDYwHZpuBM/JWP6rW4ZOD/QNh4aTCVGTWgW6AEkKS1jtkhn2G0QCwUD4SdyyYdGQzEnbjekdtjHjQBJX8PfDA7ZGK5f7EQvO9OzWOTjgzGW4CfHtPgJtaLvec1f6Qjg5mc0YurM+rH+r06f2ROY/K+d27qOt6cfq1/sXzchimQET4AAAAASUVORK5CYII=",
    height: 32,
    preserveAspectRatio: "xMidYMid meet"
  })))), /*#__PURE__*/React.createElement("radialGradient", {
    gradientTransform: "matrix(0.9942, 0, 0, -1.0058, -502.5914, -1.130001)",
    gradientUnits: "userSpaceOnUse",
    r: 20.337683,
    cx: 571.745807,
    id: "834156ddaf",
    cy: -31.08187,
    fx: 571.745807,
    fy: -31.08187
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.199463%, 65.499878%, 94.898987%)",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "rgb(48.199463%, 65.499878%, 94.898987%)",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7c1738cc85"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 102,
    y: 0,
    height: 32
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "92fdaf86d7",
    patternUnits: "userSpaceOnUse",
    width: 102,
    patternTransform: "matrix(0.992647, 0, 0, -0.992647, 78.088236, 49.751464)",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 102 32",
    height: 32,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7c1738cc85)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#f4ebe10690)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -118.560004,
    fill: "url(#834156ddaf)",
    width: 261.120008,
    height: 97.92,
    y: -32.840005
  }))))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#808e84cc6c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 22.78125 49.183594 L 14.558594 49.183594 L 14.558594 37.324219 L 9.242188 37.324219 L 9.242188 49.183594 L 0.808594 49.183594 L 0.808594 18.585938 L 9.226562 18.585938 L 9.226562 30.003906 L 14.542969 30.003906 L 14.542969 18.585938 L 22.765625 18.585938 L 22.765625 49.183594 Z M 60.46875 49.316406 C 68.882812 49.316406 75.757812 42.226562 75.757812 33.597656 C 75.757812 24.839844 68.882812 18.0625 60.46875 18.0625 C 51.9375 18.0625 47.625 24.328125 46.585938 26.890625 C 46.585938 23.097656 42.839844 18.570312 38.496094 18.570312 L 24.453125 18.570312 L 24.453125 49.183594 L 37.523438 49.183594 C 42.839844 49.183594 46.585938 44.589844 46.585938 40.554688 C 47.769531 43.046875 51.953125 49.316406 60.46875 49.316406 Z M 36.484375 36.878906 C 37.699219 36.878906 38.671875 38.078125 38.671875 39.4375 C 38.671875 40.867188 37.699219 42.0625 36.484375 42.0625 L 32.300781 42.0625 L 32.300781 36.878906 Z M 36.484375 25.394531 C 37.699219 25.394531 38.671875 26.59375 38.671875 27.953125 C 38.671875 29.316406 37.699219 30.515625 36.484375 30.515625 L 32.300781 30.515625 L 32.300781 25.394531 Z M 42.015625 33.597656 C 42.988281 33.53125 44.574219 32.402344 45.175781 31.726562 C 44.949219 32.546875 44.949219 35.140625 45.175781 35.960938 C 44.511719 34.960938 42.988281 33.777344 42.015625 33.597656 Z M 52.796875 33.597656 C 52.796875 29.285156 56.265625 25.804688 60.53125 25.824219 C 64.8125 25.855469 68.21875 29.382812 68.171875 33.714844 C 68.105469 37.980469 64.699219 41.40625 60.484375 41.40625 C 56.234375 41.40625 52.796875 37.929688 52.796875 33.597656 Z M 60.46875 39.734375 C 63.742188 39.734375 66.5 37.011719 66.5 33.597656 C 66.5 30.1875 63.742188 27.496094 60.46875 27.496094 C 57.09375 27.496094 54.402344 30.1875 54.402344 33.597656 C 54.402344 37.011719 57.09375 39.734375 60.46875 39.734375 Z M 60.46875 39.734375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ff38c60dc4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#36bfc64f65)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#61ade5e9c1)",
    d: "M 78.742188 18.046875 L 78.742188 49.316406 L 179.28125 49.316406 L 179.28125 18.046875 Z M 78.742188 18.046875 ",
    fillRule: "nonzero"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a7f663e4e2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#59ad66b149)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c6d139a629)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#67bdaaf0c7)",
    d: "M 84.984375 18.046875 L 120.855469 18.046875 L 120.855469 49.316406 L 84.984375 49.316406 Z M 84.984375 18.046875 ",
    fillRule: "nonzero"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#389b0e8da8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c1c083a194)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3296c7ad43)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#bbd02f1cf6)",
    d: "M 83.882812 21.195312 L 157.699219 21.195312 L 157.699219 49.3125 L 83.882812 49.3125 Z M 83.882812 21.195312 ",
    fillRule: "nonzero"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d76e3b230c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#46bcba62cd)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#85a71dcb96)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#92fdaf86d7)",
    d: "M 123.371094 18.046875 L 163.523438 18.046875 L 163.523438 40.144531 L 123.371094 40.144531 Z M 123.371094 18.046875 ",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHbomax);
export default __webpack_public_path__ + "static/media/hbomax.7c04f2fe518cd8fae337b437260dfb2d.svg";
export { ForwardRef as ReactComponent };